declare var Stripe: any;

import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentService } from '../../../services/payment.service';
import { HelpersService } from '../../../services/helpers.service';
import moment from 'moment';
import { AppConfig } from '../../../app.config';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-details',
  templateUrl: './card-details.component.html',
  styleUrls: ['./card-details.component.scss'],
  providers: [MessageService],
})
export class CardDetailsComponent implements OnInit {
  @Input() chosenPackage;
  @Input() messageService: MessageService;
  public stripe: any;
  public card: any;
  public processedDate = moment();
  public firstPayDay = moment().add(1, 'M');
  public coupon: any = null;

  public cardBrands: any;
  public cardNumbers: any;
  public loading = false;

  constructor(
    public router: Router,
    public modal: NgbActiveModal,
    public paymentService: PaymentService,
    public helpersService: HelpersService,
    private appConfig: AppConfig,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    const partnerId = this.helpersService.getPartnerId();
    this.paymentService.getCustomer(partnerId).subscribe((res) => {
      if (res.paymentMethod === 1) {
        this.cardBrands = res.sources.data[0].brand;
        this.cardNumbers = res.sources.data[0].last4;
      }
    });
    this.stripe = Stripe(this.appConfig.getStripKey());

    var elements = this.stripe.elements();

    this.card = elements.create('card', {
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#181818',
          color: '#181818',
          fontWeight: 500,
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',

          ':-webkit-autofill': {
            color: '#181818',
          },
          '::placeholder': {
            color: '#777',
          },
        },
        invalid: {
          iconColor: '#d90028',
          color: '#181818',
        },
      },
    });
    this.card.mount('#card-input');
  }

  submitPayment() {
    this.loading = true;
    let errorElement = document.getElementById('card-errors');
    errorElement.textContent = '';
    this.stripe.createToken(this.card).then((result) => {
      if (result.error) {
        // Inform the user if there was an error.
        errorElement.textContent = result.error.message;
        this.loading = false;
      } else {
        const partner = this.helpersService.getPartnerData();
        // Send the token to your server.
        this.paymentService
          .postPaymentStripe({
            PartnerID: partner.ID,
            CardToken: result.token.id,
            PlanID: this.chosenPackage.pricing.id,
            Coupon: this.coupon,
          })
          .subscribe(
            (res) => {
              this.messageService.add({
                life: 3000,
                detail: this.translate.instant('bikeshop.package_purchase'),
              });
              this.helpersService.savePartnerData({
                ...partner,
                PaymentMethod: 1,
              });
              this.close();
            },
            (err) => {
              this.loading = false;
              errorElement.textContent =
                err === 'Not Found' ? 'Coupon / Discount code not found' : err;
            },
          );
      }
    }),
      (err) => {
        this.loading = false;
        errorElement.textContent = err;
      };
  }

  close() {
    this.modal.close({ reload: true });
  }
}
